<div class="h-full rounded-lg p-6 border border-border space-y-4">
  <h2 class="text-2xl font-semibold">Contact details</h2>

  <div class="flex flex-col gap-1">
    <div>
      <p class="text-text-secondary">Name</p>
      <p>
        {{ contact().name }}
      </p>
    </div>
    <div>
      <p class="text-text-secondary">Phone</p>
      <p class="text-primary">
        {{ contact().phone }}
      </p>
    </div>
    <div>
      <p class="text-text-secondary">Address</p>
      <p class="text-primary">
        {{ contact().address }}
      </p>
    </div>
  </div>
</div>
